import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

/**
 * ASRS (Adult ADHD Self-Report Scale) patient self-report form entrypoint.
 *
 * We pass `formKey="asrs"` explicitly so the template binds to the correct
 * Firestore form definition by key (more robust than matching by title).
 */
export default function PatientASRSForm() {
  return (
    <PatientFormTemplate
      formTitle="Adult ADHD Self-Report Scale (ASRS)"
      formKey="asrs"
    />
  );
}

